import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../../services/auth.service';

@Injectable()
export class HomeGuard  {
    constructor(
        public _authService: AuthService
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this._authService.User.isLoggedIn)
            this._authService.redirectToDefaultDashboard();

        return true;
    }
}
